export default __webpack_public_path__ + "/dist/images/image1.jpg";